import script from "./sw-form-inputter.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-form-inputter.vue?vue&type=script&setup=true&lang=js"

import "./sw-form-inputter.vue?vue&type=style&index=0&id=d85db4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d85db4a0"]])

export default __exports__